import React, { FC } from 'react';
import { InputAdornment, IconButton } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useStyles = makeStyles({ name: 'SeePasswordButton' })(() => ({
  root: {
    '& svg': {
      fill: 'rgba(0,0,0,0.54)',
    },
  },
}));

interface Props {
  show: boolean;
  onClick: () => void;
}

export const SeePasswordButton: FC<Props> = ({ show, onClick }) => {
  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const { classes } = useStyles();

  return (
    <InputAdornment className={classes.root} position="end">
      <IconButton
        aria-label="toggle password visibility"
        onClick={onClick}
        onMouseDown={handleMouseDownPassword}
        edge="end"
      >
        {show ? <VisibilityOutlinedIcon /> : <VisibilityOffOutlinedIcon />}
      </IconButton>
    </InputAdornment>
  );
};
